import type { ColumnsType } from 'ant-design-vue/es/table';
import type { FormSchema } from '@/components/lt-a-form/src';
import type { ActionItem } from './tableAction';
import type { TableActionType } from '@/components/lt-a-table/src';
import type { DataIndex } from 'ant-design-vue/es/vc-table/interface';
import type { VNode } from 'vue';

export type ColumnType<T> = ColumnsType<T>[number];

export type CustomRenderParams<T = any> = Omit<
  Parameters<NonNullable<ColumnType<T>['customRender']>>[number],
  'column'
> & { column: TableColumn<T> };

export type CustomHeaderCellParams<T = any> = Omit<
  Parameters<NonNullable<ColumnType<T>['customHeaderCell']>>[number],
  'column'
> & { column: TableColumn<T> };

// export type EditableConfig<T = any> = {
//   /** 可编辑表格的类型，`单行编辑` | `多行编辑` | `可编辑单元格` */
//   type: 'single' | 'multiple' | 'cell';
//   /** 传递给 Form.Item 的配置,可以配置 rules */
//   formProps?: Partial<FormSchema<T>>;
//   /** 行保存的时候 */
//   onSave?: (
//     /** 行 id，一般是唯一id */
//     key: Key,
//     /** 当前修改的行的值，只有 form 在内的会被设置 */
//     record: T,
//     /** 原始值，可以用于判断是否修改 */
//     originRow: T,
//   ) => Promise<any | void>;
// };

/**
 * 表格属性
 */
export type TableColumn<T = Recordable> = ColumnType<T> & {
  dataIndex?: keyof T | ColumnKeyFlagType | Omit<DataIndex, string>;
  /** 指定搜索的字段 */
  searchField?: string;
  /** 在查询表单中不展示此项 */
  hideInSearch?: boolean;
  /** 在 Table 中不展示此列 */
  hideInTable?: boolean;
  /** 列的图元类型(input CheckBox，combox,datetime) */
  Style?: string;
  /** 传递给搜索表单 Form.Item 的配置,可以配置 rules */
  formItemProps?: Partial<FormSchema<T>>;
  /** 传递给可编辑表格 Form.Item 的配置,可以配置 rules */
  editFormItemProps?: Partial<FormSchema<T>> & {
    /**
     * 是否继承于搜索表单`TableColumn.formItemProps`的所有属性,为深拷贝合并
     * 值为`true`时的行为伪代码如下：
     * ```js
     * Object.assign({}, TableColumn.formItemProps, TableColumn.editFormItemProps)
     * ```
     * @defaultValue 默认值为`true`
     * */
    extendSearchFormProps?: boolean;
  };
  /** 操作列，一般用于对表格某一行数据进行操作 */
  actions?: (params: CustomRenderParams<T>, action: TableActionType) => ActionItem[];
  /** 当前单元格是否允许被编辑 */
  editable?: boolean | ((params: CustomRenderParams<T>) => boolean);
  /** 当前单元格是否默认开启编辑，仅 `editableType`为`cell`时有效 */
  defaultEditable?: boolean;
  bodyCell?: (params: CustomRenderParams<T>) => VNode | string;
  headerCell?: (params: CustomRenderParams<T>) => VNode | string;
  colProps: number,//生成编辑表格的时候占多少列,
  Visible: boolean

};

export enum ColumnKeyFlag {
  ACTION = 'ACTION',
  INDEX = 'INDEX',
  SHOW = 'SHOW',
}
export type ColumnKeyFlagType = `${ColumnKeyFlag}`;

export type ColumnParams<T = any> = {
  record: T;
  text: string;
  index: number;
  column: TableColumn<T>;
};


export type ColStruct = {
  Field: string;
  NameZH: string;
  NameEN: string;
  Width: number;
  Fix: boolean;
  fixed?: boolean;
  Visible: boolean;
  Style: string;
  ifShow: boolean;
  title?: string;
  dataIndex?: string;
  width?: string | number;
  Option: itemType[];
  treeOption: treeType[];
  btnOption: tableBtnOption[];
  isEdit?: boolean;
  dataType?: string;
  isRequire?: boolean;
  ReadOnly?: boolean;
  isShowInForm?: boolean;
  maxlength?: number;
  ifshowInQueryForm?: boolean
  Mode?: string
  isShowLabelInTable?: boolean //是否在表格中显示的时候，仅显示文本
  showTime: boolean,//日期的时候，是否显示时间格式
  fieldNames?: fieldNamesStruct,
  maxTagCount?:number,
  allowClear?: boolean
};

type fieldNamesStruct = {
  children: string
  label: string
  value: string
}

export type itemType = {
  key: string;
  label: string;
  value: string | number;
  labelZH?: string;
  labelEN?: string;
  color?: string;
};

type treeChild = {
  id: string;
  name: string;
  children: treeChild[];
};

interface treeType extends treeChild {
  children: treeChild[];
}

type tableBtnOption = {
  label: string;
  color: string;
  icon: string;
  divider: boolean;
  ifShow: boolean;
  tooltip: string;
  type: string;
  btnKey: string;
};
